import {Component, EventEmitter, Output} from '@angular/core';
import {BsModalRef} from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-confirmation',
  templateUrl: './confirmation.component.html',
  styleUrls: ['./confirmation.component.scss'],
  standalone: false,
})
export class ConfirmationComponent {
  @Output() confirm: EventEmitter<boolean> = new EventEmitter<boolean>();
  constructor(private bsModalRef: BsModalRef) {}

  closeModal(confirmation: boolean): void {
    this.confirm.emit(confirmation);
    this.bsModalRef.hide();
  }
}
